import type { Field } from '../models/issues/field';
import { getFormFields } from '../models/issues/field-registry';
import type { Area, Category, Department } from '../models/issues/issue';

export const getIssueFields = (
  draftIssue: {
    area?: Area;
    department?: Department;
    category?: Category;
  },
  catalogFields: Record<string, Field> = {}
): string[] => {
  const { category, department } = draftIssue;

  if (category?.fields && category.fields.length > 0) {
    const formFields = getFormFields(
      category.fields.map((f) => f.key),
      catalogFields
    );

    return formFields.length > 0 ? formFields : ['description', 'attachments'];
  }

  // Direct-to-summary department flow: no category selected but department has fields
  if (department?.fields && department.fields.length > 0) {
    const formFields = getFormFields(
      department.fields.map((f) => f.key),
      catalogFields
    );

    return formFields.length > 0 ? formFields : ['description', 'attachments'];
  }

  return ['description', 'attachments'];
};
